/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Guide_Restricted_Access_TextInputs */



/**
* | output |
* | --- |
* | "Limited to {count} group(s)." |
*
* @param {Knp_Guide_Restricted_Access_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_restricted_access_text = /** @type {((inputs: Knp_Guide_Restricted_Access_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Restricted_Access_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Limité à ${i?.count} groupe(s).`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Beschränkt auf die Gruppe(n) ${i?.count}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Limitato a ${i?.count} gruppi.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ограничено группой(ами) ${i?.count}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Limitado a ${i?.count} grupo(s).`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`仅限 ${i?.count} 组。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} グループに限定されます。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`केवल ${i?.count} समूह(समूहों) तक सीमित।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Limitado ao(s) grupo(s) ${i?.count}.`)
	return /** @type {LocalizedString} */ (`Limited to ${i?.count} group(s).`)
});